import React from 'react';
import { Copyright } from 'components/atoms/copyright';
import { Icon } from 'components/atoms/icon';
import './style.scss';

// TODO: Needs to be renamed
export const SocialLinks = ({ links }) => {
  if (!links) {
    return null;
  }
  return (
    <>
      <div className="social-links">
        {Object.keys(links).map((link, idx) => {
          if(!links[link]) return;
          return (
            <a
              href={links[link]}
              target={'_blank'}
              key={idx}
              rel="noopener noreferrer"
            >
              <Icon name={link.replace('_url', '')} />
            </a>
          );
        })}
      </div>
      <Copyright containerClass={'menu-copyright'} />
    </>
  );
};
